import emptySliceApi from '../../../shared/store/emptyApiSlice';

interface UpdateAccount2faApiRequest {
  accountId: string;
  twoFaInterval: number;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateAccount2fa: builder.mutation<void, UpdateAccount2faApiRequest>({
      query: ({ accountId, twoFaInterval }) => ({
        url: `v4/accounts/${accountId}/2fa`,
        method: 'PUT',
        body: { twoFaInterval },
      }),
      invalidatesTags: ['AccountData'],
    }),
  }),
});

export const { useUpdateAccount2faMutation } = apiSlice;
